<template>





<v-container>

<v-content>

<v-card
    class="mt-4 mx-auto"
    max-width="600"
    max-length="600"
  >
 <v-card-title>{{schoolName}}</v-card-title>
 <v-card-title>Weekly Recap</v-card-title>
 <v-card-subtitle>Great Job this Week 👍</v-card-subtitle>
  <v-sparkline
        :labels="labels"
        :value="value"
        :gradient="gradient"
        line-width="2"
        padding="16"
      ></v-sparkline>
<v-card-text class="pt-0">
      <div class="text-h6 font-weight-light mb-2">
        Dismissal(s) by Day
      </div>
    </v-card-text>
      <v-data-table
    v-model="selectedRow"
    :headers="headers"
    :items-per-page="itemsPerPage"
    :items="items"
    item-key="id"
    class="elevation-1"
    hide-default-footer
  >
<!--<template v-slot:item.carlinE_DATE="{ item }">


  {{item.carlinE_DATE}}

    
 </template>-->


  </v-data-table>

    
  </v-card>


<v-card
 class="mt-4 mx-auto"
    max-width="600"
    max-length="600"
>
 
 <v-card-title>  <v-icon
      large
      color="primary"
    >
      mdi-clock
    </v-icon> Avg Duration (HH:MM:SS)</v-card-title>


<center>
 <p style="font-weight: bold; font-size: 250% ; color: black;">
      {{ avgTime }}
      </p>
</center>

</v-card>

<v-card
 class="mt-4 mx-auto"
    max-width="600"
    max-length="600"
>
<v-card-title>  <v-icon
      large
      color="primary"
    >
      mdi-car
    </v-icon>Avg Dismissed</v-card-title>

<center>
 <p style="font-weight: bold; font-size: 300% ; color: black;">
      {{ avgDismissed }}
      </p>
</center>

</v-card>


<v-card
 class="mt-4 mx-auto"
    max-width="600"
    max-length="600"
>
<v-card-title>  <v-icon
      large
      color="primary"
    >
      mdi-traffic-light
    </v-icon>Peak Traffic</v-card-title>

<center>
 <p style="font-weight: bold; font-size: 300% ; color: black;">
    {{peakTraffic}}
      </p>
</center>

</v-card>



<v-card v-if="fasterCarline"
 class="mt-4 mx-auto"
    max-width="600"
    max-length="600"
>
<v-card-title>  <v-icon
      large
      color="error"
    >
      mdi-widgets
    </v-icon>How do you compare?</v-card-title>

<center>
 <p style="font-weight: bold; font-size: 120% ; color: dark gray;">
   You're crusing it 👊 <br>
     <v-icon
      large
      color="success"
    >
      mdi-trending-up
    </v-icon> Your school is faster than other schools by: {{compareTime}} min(s)
      </p>
   </center>  


</v-card>


</v-content>
</v-container>
   
     

  
  






    


    




    





  
</template>


<script>


const gradients = [
    ['#222'],
    ['#42b3f4'],
    ['red', 'orange', 'yellow'],
    ['purple', 'violet'],
    ['#00c6ff', '#F0F', '#FF0'],
    ['#f72047', '#ffd200', '#1feaea'],
  ]


  import axios from 'axios';
  import store from '../store';
  import moment from 'moment-timezone';

  export default {
    components: {

    },
    data: () => ({
      passwordAlert: false,
      gradient: gradients[5],
       labels: [
      ],
      value: [
      ],
      avgTime:'',
      selectedRow: [],
        itemsPerPage: 30,
        headers: [
          { text: 'Date', value: 'datE_STRING' },
          { text: 'Students', value: 'dismissaL_COUNT' },
        ],
      items: [],
      carlineReport: [],
      avgDismissed: '0',
      gValue: '35',
      peakTraffic: '2:35 PM',
      fasterCarline: false,
      message: '',
      alert: false,
      loaded: false,
      exampleValue: 35,
      schoolName: '',
      results: {},
      timeToLoad: 0,
      onLine: null,
      pId: '',
      companyName: '',
      jwsToken: '',
      username: '',
      password: '',
      reTypePassword: '',
      valid: true,
      totalTime: '',
      compareTime: '',
      validCode: false,
      invalidCode: false,
      name: '',
      accessToken: '',
      nameRules: [
        v => !!v || 'Field is required',
        v => (v && v.length <= 10) || 'Name must be less than 10 characters',
      ],
      email: '',
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      ],
    }),

    mounted: function() {
    

      this.companyName = this.$route.query.uuid;

      /*console.log(this.items[0].dismissaL_COUNT);

      this.schoolName = this.carlineReport[0].schooL_NAME;
      this.avgTime = this.carlineReport[0].avG_TIME;
      this.totalTime = this.carlineReport[0].totaL_TIME;
      console.log("Hey here are the minutes: " + moment.duration(this.avgTime).asMinutes().toFixed(2));
      this.avgDismissed = this.carlineReport[0].dismissaL_AVG_COUNT;
      this.timeToLoad = this.avgDismissed / moment.duration(this.avgTime).asMinutes()
      this.timeToLoad = this.timeToLoad.toFixed(2) + ' min'

      this.compareTime = moment.duration(this.totalTime).asMinutes().toFixed(0) - moment.duration(this.avgTime).asMinutes().toFixed(0)
      
      console.log("This is where your at: " + this.compareTime)

      if (this.compareTime > 0) {

        this.fasterCarline = true;
      }

      for (var i = 0; i < this.items.length; i++) {

         this.value.push(this.items[i].dismissaL_COUNT);

      }*/

      this.getCarlineChart(this.companyName);
      this.getCarlineReport(this.companyName);


   
  },



    methods: {



        getCarlineChart(compName) {

  

      axios.get('https://api.conciergepadedu.com/api/Metrics/' + compName).then(response => {

      if (response.data.error) {

        console.log("ERROR");
     

      } else {

        console.log("SUCCESS");
        console.log(response.data);

        this.items = response.data;
        


        for (var i = 0; i < this.items.length; i++) {

          this.value.push(this.items[i].dismissaL_COUNT);
          this.labels.push(this.items[i].dow);
          

        }

       

        }

        }).catch(error => {

            console.log(error.response);
            console.log("CATCH");
           

        });

    },

    getCarlineReport(compName) {

  

      axios.get('https://api.conciergepadedu.com/api/Metrics/GetCarlineReport/' + compName).then(response => {

      if (response.data.error) {

        console.log("ERROR");
     

      } else {

        console.log("SUCCESS");
        console.log(response.data);

        this.carlineReport = response.data;


        this.schoolName = this.carlineReport[0].schooL_NAME;
        this.avgTime = this.carlineReport[0].avG_TIME;
        this.totalTime = this.carlineReport[0].totaL_TIME;
        console.log("Hey here are the minutes: " + moment.duration(this.avgTime).asMinutes().toFixed(2));
        this.avgDismissed = this.carlineReport[0].dismissaL_AVG_COUNT;
        this.peakTraffic = this.carlineReport[0].peaK_TRAFFIC;
        this.timeToLoad = this.avgDismissed / moment.duration(this.avgTime).asMinutes()
        this.timeToLoad = this.timeToLoad.toFixed(2) + ' min'

        this.compareTime = moment.duration(this.totalTime).asMinutes().toFixed(0) - moment.duration(this.avgTime).asMinutes().toFixed(0)
      
        console.log("This is where your at: " + this.compareTime)

        if (this.compareTime > 0) {

            this.fasterCarline = true;
        }

       

        }

        }).catch(error => {

            console.log(error.response);
            console.log("CATCH");
           

        });

    },

  simpleDate(value) {
      return moment(value).format("MM/DD/YY")
    },

 formatDate(value) {
      
      console.log("Here is the date: " + value)

      var date = new Date(value);
return  moment(date).format('D MMMM YYYY');

      //return moment(value).format('DD-MM-YYYY');
        },

        durationFormat(value) {
            const duration = moment.duration(value);
            return duration.hours() + 'h ' + duration.minutes() + 's';
        },

    lostPassword() {

      console.log("GO TO LOST PASSWORD");


      //this.$router.push('Lost'); 

      //window.location.href = "https://www.conciergepadedu.com/lost_password.aspx"

      window.open("https://www.conciergepadedu.com/lost_password.aspx", "_blank");    

    },
    status(ele) {
        console.log("In the internet status " + ele);
        this.onLine = ele;
      },
      event(ele) {
        console.log("In the internet event " + ele);
      },
      
    buttonPressed() {

        this.loaded = true

        //if (this.emailValue != "" && this.password != "") {
        if (this.emailValue && this.password) {

  console.log("Here in username and password");

  axios
    .post(
      "https://api.conciergepadedu.com/api/auth/cptoken",
      {
         USERNAME: this.emailValue,
         PASSWORD: this.password 
      }
    )
    .then(response => {

      if (response.data.error) {

        console.log("Error on token");
        console.log(response.data.error);
        this.loaded = false;

        this.$alert("Login not successful","Login","error");


      } else {
      //this.resp = response;

      this.results = response.data

      console.log(response.data);

      console.log("Token");

        this.accessToken = JSON.stringify(response.data);


        this.jwsToken = response.data;

        console.log("data")
        console.log(this.jwsToken)
  
        this.bearerConfig = {
            headers: {
            Authorization: "Bearer " + response.data
            }
        }


      axios.get('https://api.conciergepadedu.com/api/Profiles/' +  this.emailValue,this.bearerConfig).then(response => {

      if (response.data.error) {

          console.log("ERROR");
          console.log('error', response.data.error);
          this.loaded = false

          //this.emailValue = ''
          //this.password = ''

          this.$alert("Login not successful","Login","error");

        

      } else {

        this.postStatus = true;

        console.log('success', response.data)

        this.results = response.data
  
         const payload = {'token': this.jwsToken, 'user': this.results.username,'comp':this.results.companY_NAME,'email':this.results.username,'pId':this.results.id,'password':this.results.password}
         store.dispatch('addAuth',payload);

         localStorage.setItem('jwsToken', JSON.stringify(this.jwsToken));


        this.loaded = false


        //this.$router.push('TrackingDetail') 

        this.$router.push({ path: 'dismissal', query: { uuid: this.results.companY_NAME, user: this.emailValue }})

        }

        }).catch(error => {

            this.loaded = false
            console.log("CATCH ERROR");
            console.log(error.response);

            this.emailValue = ''
            this.password = ''

            this.$alert("Login not successful","Login","error");


        });


      }


      }).catch(error => {


      console.log("Catch Error (1)");

      console.log(error);
      console.log(error.message);

      this.$alert("Login not successful","Login","error");

     this.loaded = false;


    })

  } else {


    console.log("No Username or Password");
    this.loaded = false;

   
      }

    

 

} ,
      validate () {
        this.$refs.form.validate()
      },
      reset () {
        this.$refs.form.reset()
      },
      resetValidation () {
        this.$refs.form.resetValidation()
      },
    },
  }
</script>


<style>
  .v-text-field input {
    font-size: 100;
  }
</style>